// Solar Icons
import moneyBag from '@iconify/icons-solar/money-bag-bold';
import calendarMark from '@iconify/icons-solar/calendar-mark-bold-duotone';
import clockCircle from '@iconify/icons-solar/clock-circle-outline';
import altArrowUp from '@iconify/icons-solar/alt-arrow-up-bold-duotone';
import altArrowDown from '@iconify/icons-solar/alt-arrow-down-bold-duotone';
import filterBold from '@iconify/icons-solar/filter-bold';
import eyeBold from '@iconify/icons-solar/eye-bold';
import eyeClosedBold from '@iconify/icons-solar/eye-closed-bold';
import exportBold from '@iconify/icons-solar/export-bold';
import usersGroupRounded from '@iconify/icons-solar/users-group-rounded-bold';
import userIdBold from '@iconify/icons-solar/user-id-bold';
import phoneBold from '@iconify/icons-solar/phone-bold';

// Eva Icons
import closeFill from '@iconify/icons-eva/close-fill';
import searchFill from '@iconify/icons-eva/search-fill';
import arrowDown from '@iconify/icons-eva/arrow-ios-downward-fill';
import arrowUp from '@iconify/icons-eva/arrow-ios-upward-fill';
import chevronDown from '@iconify/icons-eva/chevron-down-fill';
import arrowBack from '@iconify/icons-eva/arrow-ios-back-fill';
import arrowForward from '@iconify/icons-eva/arrow-ios-forward-fill';

// Mingcute Icons
import moreFill from '@iconify/icons-mingcute/more-1-fill';
import rows4Fill from '@iconify/icons-mingcute/rows-4-fill';
import rows2Fill from '@iconify/icons-mingcute/rows-2-fill';
import birthdayFill from '@iconify/icons-mingcute/birthday-2-fill';
import locationFill from '@iconify/icons-mingcute/location-fill';

// Material Symbol Icons
import person from '@iconify/icons-material-symbols/person';
import tableRowsNarrow from '@iconify/icons-material-symbols/table-rows-narrow-rounded';
import helpIcon from '@iconify/icons-material-symbols/help';

const iconMap = {
  'eva:arrow-ios-downward-fill': arrowDown,
  'eva:arrow-ios-upward-fill': arrowUp,
  'solar:money-bag-bold': moneyBag,
  'eva:chevron-down-fill': chevronDown,
  'eva:arrow-ios-back-fill': arrowBack,
  'eva:arrow-ios-forward-fill': arrowForward,
  'solar:calendar-mark-bold-duotone': calendarMark,
  'solar:clock-circle-outline': clockCircle,
  'solar:alt-arrow-up-bold-duotone': altArrowUp,
  'solar:alt-arrow-down-bold-duotone': altArrowDown,
  'solar:filter-bold': filterBold,
  'solar:eye-bold': eyeBold,
  'solar:eye-closed-bold': eyeClosedBold,
  'solar:export-bold': exportBold,
  'eva:close-fill': closeFill,
  'eva:search-fill': searchFill,
  'mingcute:more-1-fill': moreFill,
  'mingcute:rows-4-fill': rows4Fill,
  'mingcute:rows-2-fill': rows2Fill,
  'solar:users-group-rounded-bold': usersGroupRounded,
  'solar:user-id-bold': userIdBold,
  'solar:phone-bold': phoneBold,
  'mingcute:birthday-2-fill': birthdayFill,
  "material-symbols:person": person,
  "material-symbols:table-rows-narrow-rounded": tableRowsNarrow,
  "material-symbols:help": helpIcon,
  "mingcute:location-fill": locationFill
} as const;

export default iconMap;
